import { render } from "./RepresentationSettings.vue?vue&type=template&id=5e09ae48"
import script from "./RepresentationSettings.vue?vue&type=script&lang=js"
export * from "./RepresentationSettings.vue?vue&type=script&lang=js"

import "./RepresentationSettings.vue?vue&type=style&index=0&id=5e09ae48&lang=css"
script.render = render

export default script